/**
 * @param {string} string
 * @return {string}
 */
export const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1);

// TODO: Fix later in https://ticket.ertelecom.ru/browse/WEB-43177
/**
* @param {string} text
* @return {string}
*/
export const clearHTMLTags = (text = '') => text.replace(/<[^>]+>/g, '');

export const clearNbsp = (text = '') => text.replace(/&nbsp;/g, '');
